export class EMASmoother {
    constructor(alpha = 0.5, minCutoff = 1, beta = 0.0) {
        this.alpha = alpha; // Smoothing factor (0 < alpha < 1). Lower = more smoothing, more lag.
        this.data = null;
    }

    process(landmarks) {
        if (!landmarks) return null;

        if (!this.data) {
            // First frame, initialize
            this.data = landmarks.map(l => ({ x: l.x, y: l.y, z: l.z, visibility: l.visibility }));
            return this.data;
        }

        // Apply EMA
        this.data = landmarks.map((curr, i) => {
            const prev = this.data[i];
            if (!prev) return curr;

            return {
                x: (curr.x * this.alpha) + (prev.x * (1 - this.alpha)),
                y: (curr.y * this.alpha) + (prev.y * (1 - this.alpha)),
                z: (curr.z * this.alpha) + (prev.z * (1 - this.alpha)),
                visibility: curr.visibility
            };
        });

        return this.data;
    }

    reset() {
        this.data = null;
    }
}
